<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2YjiSw/tc-custom/9781426841200.jpg?1726574123480" alt="This image is the cover for the book From Waif to Gentleman's Wife, The Wellingfords"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Waif to Gentleman's Wife, The Wellingfords
      </h1>
      <p class="bookDescription body article font2">
        <p>When a destitute governess faints on Sir Edward Greaves's threshold, chivalry demands that he offer her temporary shelter. However, the desire Ned feels when he catches her in his arms isn't at all gentlemanly….<br/><br/>With her large, troubled eyes and slender frame, Joanna Merrill calls to something deep inside this guarded man. For one who has purposely shunned the conniving beauties of London society, just how much is Ned risking by having this intriguing woman under his roof…?<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julia Justiss
      </h2>
      
      <p class="authorDescription body article">Long before embarking on romantic adventures of her own, Julia Justiss read about them, transporting herself to&#160;such favourite venues as ancient Egypt, World War II submarine patrols, the Old South and, of course, Regency England. Soon she was keeping notebooks for jotting down story ideas. When not writing or traveling, she enjoys watching movies, reading and puttering about in the garden trying to kill off more weeds than flowers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?785e0d5c